import WelcomeTypes from '~/constants/types/WelcomeTypes';
import {createAction} from 'redux-actions';

export const setRestingScreenState = createAction(
  WelcomeTypes.SET_RESTING_STATE
);
